<template>
  <div class="general-cards-message">
    <div class="warpper">
      <!-- 20191217新增 :mouseDrag="false"-->
      <carousel
        v-if="contentCount > 1 && direction === 'h'"
        :nav="false"
        :mouseDrag="false"
        :dots="false"
        :margin="2"
        :loop="false"
        :auto-width="true"
        :rtl="true"
        class="rich_carousel">

        <!-- 20191217新增 -->
        <template v-if="!isMobile" slot="prev"><span class="prev">prev</span></template>

        <dl v-for="(r, index) of content.cards" :key="index">
          <dd>
            <div class="card_single">
              <div class="img" v-if="r.imageUrl && r.imageUrl !== ''" @click="returnJSONtoMobile_(r.payload)">
                <a>
                  <img :src="r.imageUrl" alt="圖片說明">
                </a>
              </div>

              <div class="content">

                <div class="info" @click="returnJSONtoMobile_(r.payload)">
                  <h2 class="rich-titlle">{{ r.title }}</h2>
                  <p class="rich-subtitle">{{ r.subtitle }}</p>
                </div>
                <div class="rich-btn">

                  <button
                    v-for="(b,index) of r.buttons"
                    :key="index"
                    @click="openTargetUrl(b.payload, b.actionType)">
                  <a v-if="b.actionType == 'text'">{{ b.title }}</a>

                  <a
                  v-if="b.actionType == 'url' && (!isApp || (isApp && projectId != 'udn')) "
                  style="color:#000;text-decoration: none"
                  :href="b.payload" target="_blank">{{ b.title }}</a>

                  <a
                  v-if="b.actionType == 'url' && isApp && projectId == 'udn'"
                  style="color:#000;text-decoration: none"
                  @click="returnJSONtoMobile_(b.payload)">{{ b.title }}</a>

                  <a v-if="b.actionType == 'email'" :href="b.payload" style="color:#000;text-decoration: none" target="_blank">{{ b.title }}</a>
                  <a v-if="b.actionType == 'phone'" :href="b.payload" style="color:#000;text-decoration: none">{{ b.title }}</a>
                  </button>
                </div>
              </div>
            </div>
          </dd>
        </dl>

        <!-- 20191217新增 -->
        <template v-if="!isMobile" slot="next"><span class="next">next</span></template>

      </carousel>

      <div v-if="contentCount > 1 && direction == 'v' || contentCount == 1" >
        <dl v-for="(r, index) of content.cards" :key="index">
            <br>
            <div class="rich_card float-right">
              <div class="card_single">
                <div class="img" v-if="r.imageUrl" @click="returnJSONtoMobile_(r.payload)">
                  <a>
                    <img :src="r.imageUrl" alt="圖片說明">
                  </a>
                </div>
                <div class="content">
                  <div class="info" @click="returnJSONtoMobile_(r.payload)">
                    <h2 class="rich-titlle">{{ r.title }}</h2>
                    <p class="rich-subtitle">{{ r.subtitle }}</p>
                  </div>
                  <div class="rich-btn">
                    <button
                      v-for="(b,index) of r.buttons"
                      :key="index"
                      @click="openTargetUrl(b.payload, b.actionType)">
                    <a v-if="b.actionType == 'text'">{{ b.title }}</a>
                    <a v-if="b.actionType == 'postmessage'">{{ b.title }}</a>

                    <a
                    v-if="b.actionType == 'url' && (!isApp || (isAPP && projectId != 'udn')) "
                    style="color:#000;text-decoration: none"
                    :href="b.payload" target="_blank">{{ b.title }}</a>

                    <a
                    v-if="b.actionType == 'url' && isApp && projectId == 'udn'"
                    style="color:#000;text-decoration: none"
                    @click="returnJSONtoMobile_(b.payload)">{{ b.title }}</a>

                    <a v-if="b.actionType == 'email'" style="color:#000;text-decoration: none" :href="b.payload" target="_blank">{{ b.title }}</a>
                    <a v-if="b.actionType == 'phone'" style="color:#000;text-decoration: none" :href="b.payload">{{ b.title }}</a>
                    </button>
                  </div>
                </div>
              </div>
            </div>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "v-owl-carousel";
export default {
  data() {
    return {
    }
  },
  components: {
    carousel
  },
  props: {
    message: {
      type: Object,
      required: true,
      default: () => {}
    },
    projectId: {
      type: String,
      default: () => ''
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    isApp: {
      type: Boolean,
      default: false
    },
    returnJSONtoMobile: {
      type: Function,
      required: true
    }
  },
  computed: {
    content() {
      var contentData = {}
      contentData = JSON.parse(this.message.msgJson)
      for (let i = 0; i < contentData.cards.length; i++) {
        // console.log('圖文卡片 : ' + JSON.stringify(contentData.cards[i]))
        // 處理 超連結 和 email (這裡不需要)
        // this.$set(contentData.cards[i], 'text', this.$handleMessageText(JSON.parse(this.message.msgJson).cards[i].text))/images/carousel/squirrel.jpg
        // 處理按鈕的 email
        for (let j = 0; j < contentData.cards[i].buttons.length; j++) {
          // console.log(contentData.cards[i].buttons[j].actionType)
          if (contentData.cards[i].buttons[j].actionType === 'email') {
            contentData.cards[i].buttons[j].payload = 'mailto:' +
            contentData.cards[i].buttons[j].payload
          } else if (contentData.cards[i].buttons[j].actionType === 'phone') {
            contentData.cards[i].buttons[j].payload = 'tel:' +
            contentData.cards[i].buttons[j].payload
          }
        }
      }
      // console.log(contentData.cards[0].text)
      // return JSON.parse(this.message.msgJson)
      return contentData
    },
    direction(){
      if ('direction' in JSON.parse(this.message.msgJson)) {
        // console.log('有此參數，採用設定:' + JSON.parse(this.message.msgJson).direction)
        return JSON.parse(this.message.msgJson).direction
      } else {
        // console.log('無此參數，預設橫向')
        return 'h'
      }
    },
    contentCount(){
      const count = JSON.parse(this.message.msgJson).cards.length
      return count;
    }
  },
  methods: {
    openTargetUrl(payload, actionType) {
      if(actionType == 'text' || actionType == 'postmessage') {
        this.$emit("tag-clicked", payload)
      }
    },
    returnJSONtoMobile_(payload) {
      // https://udn.com/news/story/7253/4321013?from=udn-catebreaknews_ch2
      // https://udn.com/news/story/6809/4320777
      // {"categoryId":6813,"articleId":4320991,"date":20200504}
      // console.log('20200207 : ' + payload)
      // console.log('20200207 : ' + this.isApp)
      // console.log('20200207 : ' + this.projectId)
      if (this.isApp && this.projectId == 'udn' && payload != undefined) {

        // --------------------------------------------------------
        // 即時、熱門等可以開啟的新聞：
        // https://udn.com/news/story/120944/4383065?from=udn-ch1_breaknews-1-0-news
        var domeString1 = 'https://udn.com/news/story/'
        var domeLength1 = domeString1.length
        // --------------------------------------------------------
        // 娛樂，目前不能開啟：
        // https://stars.udn.com/star/story/10091/4383081
        var domeString2 = 'https://stars.udn.com/star/story/'
        var domeLength2 = domeString2.length
        // ---------------------------------------------------------
        // 健康，目前不能開啟：
        // https://health.udn.com/health/story/120952/4382477
        var domeString3 = 'https://health.udn.com/health/story/'
        var domeLength3 = domeString3.length
        // ---------------------------------------------------------
        // 房地產，雖然現在bot沒有列出，但他的網址也比較特別：
        // https://house.udn.com/house/story/5888/4382577
        var domeString4 = 'https://house.udn.com/house/story/'
        var domeLength4 = domeString4.length

        if (payload.substring(0,domeLength1) == domeString1) {
          // 擷取網域後的字串
          var paramString = payload.substring(domeLength1,payload.length)
          var paramArrayTemp = paramString.split('?')
          var paramArray = paramArrayTemp[0].split('/')
          // console.log('20200207 : ' + paramArray[0])
          // console.log('20200207 : ' + paramArray[1])
          // var jsonString = '{"categoryId":' + paramArray[0] + ',"articleId":' + paramArray[1] + '}'

          // ios 要看的 gps 資料
          var ios_gps = ''
          if (localStorage.getItem('GPSLocationData') != null && localStorage.getItem('GPSLocationData') != '') {
            ios_gps = localStorage.getItem('GPSLocationData')
            console.log('20200224 ios_gps : ' + ios_gps)
          }

          var jsonString = '{"gps":"' + ios_gps + '","url":"' + payload + '","categoryId":"' + paramArray[0] + '","articleId":"' + paramArray[1] + '"}'
          this.returnJSONtoMobile(jsonString)

        } else if (payload.substring(0,domeLength2) == domeString2) {
          // 擷取網域後的字串
          var paramString = payload.substring(domeLength2,payload.length)
          var paramArrayTemp = paramString.split('?')
          var paramArray = paramArrayTemp[0].split('/')
          // console.log('20200207 : ' + paramArray[0])
          // console.log('20200207 : ' + paramArray[1])
          // var jsonString = '{"categoryId":' + paramArray[0] + ',"articleId":' + paramArray[1] + '}'

          // ios 要看的 gps 資料
          var ios_gps = ''
          if (localStorage.getItem('GPSLocationData') != null && localStorage.getItem('GPSLocationData') != '') {
            ios_gps = localStorage.getItem('GPSLocationData')
            console.log('20200224 ios_gps : ' + ios_gps)
          }

          var jsonString = '{"gps":"' + ios_gps + '","url":"' + payload + '","categoryId":"' + paramArray[0] + '","articleId":"' + paramArray[1] + '"}'
          this.returnJSONtoMobile(jsonString)

        } else if (payload.substring(0,domeLength3) == domeString3) {
          // 擷取網域後的字串
          var paramString = payload.substring(domeLength3,payload.length)
          var paramArrayTemp = paramString.split('?')
          var paramArray = paramArrayTemp[0].split('/')
          // console.log('20200207 : ' + paramArray[0])
          // console.log('20200207 : ' + paramArray[1])
          // var jsonString = '{"categoryId":' + paramArray[0] + ',"articleId":' + paramArray[1] + '}'

          // ios 要看的 gps 資料
          var ios_gps = ''
          if (localStorage.getItem('GPSLocationData') != null && localStorage.getItem('GPSLocationData') != '') {
            ios_gps = localStorage.getItem('GPSLocationData')
            console.log('20200224 ios_gps : ' + ios_gps)
          }

          var jsonString = '{"gps":"' + ios_gps + '","url":"' + payload + '","categoryId":"' + paramArray[0] + '","articleId":"' + paramArray[1] + '"}'
          this.returnJSONtoMobile(jsonString)
        } else if (payload.substring(0,domeLength4) == domeString4) {
          // 擷取網域後的字串
          var paramString = payload.substring(domeLength4,payload.length)
          var paramArrayTemp = paramString.split('?')
          var paramArray = paramArrayTemp[0].split('/')
          // console.log('20200207 : ' + paramArray[0])
          // console.log('20200207 : ' + paramArray[1])
          // var jsonString = '{"categoryId":' + paramArray[0] + ',"articleId":' + paramArray[1] + '}'

          // ios 要看的 gps 資料
          var ios_gps = ''
          if (localStorage.getItem('GPSLocationData') != null && localStorage.getItem('GPSLocationData') != '') {
            ios_gps = localStorage.getItem('GPSLocationData')
            console.log('20200224 ios_gps : ' + ios_gps)
          }

          var jsonString = '{"gps":"' + ios_gps + '","url":"' + payload + '","categoryId":"' + paramArray[0] + '","articleId":"' + paramArray[1] + '"}'
          this.returnJSONtoMobile(jsonString)
        } else {

          // ---------------------------------------------------------
          // 其他網址

          // ios 要看的 gps 資料
          var ios_gps = ''
          if (localStorage.getItem('GPSLocationData') != null && localStorage.getItem('GPSLocationData') != '') {
            ios_gps = localStorage.getItem('GPSLocationData')
            console.log('20200224 ios_gps : ' + ios_gps)
          }

          var jsonString = '{"gps":"' + ios_gps + '","url":"' + payload + '","categoryId":"","articleId":""}'
          this.returnJSONtoMobile(jsonString)
        }

      }

    }
  }
};
</script>

<style scoped>
@import "./styles/generalCardsMessage.css";
@import "./styles/rich_carousel.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/GeneralCardsMessage.vue